import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import IconArrowRight from '../../../../../components/icon/IconArrowRight';
import Modal from '../../dashboard/Modal/Modal';
import IconRotate from '../../../../../components/icon/IconRotate';
import './applicationinfo.scss';

const ApplicationInfo = () => {
  const { id } = useParams();
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    axios
      .post('https://muhlat.alif.tj/api/covidalif/v0/application/info', {
        id: +id,
      })
      .then((response) => {
        console.log(response);
        setTableData(response.data.payload[0]);
      })
      .catch((error) => {
        console.log('err: ', error);
      });
  }, [id]);

  let datas = [];

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const userStatus = {
    consideration: 'РАССМАТРИВАЕТСЯ',
    approved: 'ОДОБРЕНО',
    checking: 'НА ПРОВЕРКУ',
    considered: 'РАССМОТРЕНО',
    denied: 'ОТКАЗАНО',
    processed: 'ОБРАБОТАН',
    received: 'ПРИНЯТО',
  };

  return (
    <div>
      <div className="information-top-header">
        <Link to="/admin/applications">
          <span>Заявки</span>
        </Link>
        <IconArrowRight /> <span>{tableData.full_name} </span>
      </div>
      <div className="row">
        <div style={{ overflow: 'scroll' }} className="col-12">
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Номер транша</th>
                <th>Новая дата оплаты</th>
                <th>Старая дата оплаты</th>
                <th>Статус</th>
                <th>Дата создание заявки</th>
                <th>Дата изменение заявки</th>
                <th>История</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{tableData.id}</td>
                <td>{tableData.number}</td>
                <td>{tableData.new_date}</td>
                <td>{tableData.old_date}</td>
                <td>
                  <span className={`status-${tableData.status}`}>
                    {userStatus[tableData.status]}
                  </span>
                </td>
                <td>{tableData.create_date}</td>
                <td>{tableData.last_update}</td>
                <td onClick={handleOpenModal} className="modal-button-div">
                  <IconRotate />
                  Подробно
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ApplicationInfo;
